import { setRequestId } from "src/reducers/slices/RequestIdSlice";
import store from "src/store/store";
import { v4 as uuidv4 } from "uuid";

export const initializeRequestId = () => {
    const requestId = uuidv4();
    store.dispatch(setRequestId(requestId)); // Store in Redux
};


export const getRequestHeaders = (url: string) => {
    const state = store.getState();
    const requestId = state.requestId.requestId; // Get from Redux
    const adfsToken = sessionStorage.adfsToken;
    const BEARER_TOKEN_PREFIX = "Bearer ";

    const headers: Record<string, string> = {
        Authorization: BEARER_TOKEN_PREFIX + adfsToken,
    };

    if (!url.includes("/content")) {
        headers.requestId = requestId || "";
    }

    return { headers, adfsToken };
};